import { render, staticRenderFns } from "./orderSuccess.vue?vue&type=template&id=42f94553&scoped=true&"
import script from "./orderSuccess.vue?vue&type=script&lang=js&"
export * from "./orderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./orderSuccess.vue?vue&type=style&index=0&id=42f94553&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f94553",
  null
  
)

export default component.exports